var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 14.7,
  width: 19,
  height: 2.6,
  rx: 1.3,
  fill: "#8f9ba3"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 10,
  width: 3.8,
  height: 12,
  rx: 1.5,
  fill: "#3f4a54"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 10.2,
  y: 11.5,
  width: 3,
  height: 9,
  rx: 1.3,
  fill: "#3f4a54"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 25.8,
  y: 11.5,
  width: 3,
  height: 9,
  rx: 1.3,
  fill: "#3f4a54"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 29.2,
  y: 10,
  width: 3.8,
  height: 12,
  rx: 1.5,
  fill: "#3f4a54"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m27.8 29.5c0-5 9.4-5 9.4 0",
  fill: "none",
  stroke: "#d84338",
  strokeWidth: 2.6,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.5,
  cy: 33,
  r: 5.2,
  fill: "#d84338"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 38.2,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

function SvgFitnessEquipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessEquipment);
export default __webpack_public_path__ + "static/media/fitness-equipment.ca5ff9a56a28bce779ae1e5d96548dd9.svg";
export { ForwardRef as ReactComponent };